<template>
  <b-overlay :show="loading">
    <div v-if="inPreview">
      <a
        :href="pdfUrl"
        v-if="pdfUrl" target="_blank"
      >
        <h5
          class="text-primary underline d-inline-block mr-2"
          data-cy="document-viewer"
        >
          * Visualizando documento
          <small>(Guía de Recepción Conforme)</small> *
        </h5>
        <feather-icon icon="ExternalLinkIcon" />
      </a>
      <pdf-preview-complete
        :inPreview="inPreview"
        :generatingPreview="generatingPreview"
        :saving="saving"
        :pdfUrl="pdfUrl"
        @in-preview="inPreview = $event"
        :backToForm="backToForm"
        :save="save"
      />
    </div>
    <div v-else>
      <form autocomplete="off" @submit.prevent>
        <h2>GUÍA DE RECEPCIÓN CONFORME</h2>
        <div class="row mt-10">
          <div class="col-12">
            <b-form-group>
              <label for="previousDocument">
                ¿Deseas basarte en otro documento?
              </label>
              <v-select
                v-model="previousDocument"
                :options="createdDocuments"
                name="previousDocument"
                label="label"
                data-cy="created-document-data"
                @input="getDocumentData($event)"
                :clearable="true"
              >
                <template slot="no-options">
                  no hay documentos registrados
                </template>
              </v-select>
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-4" v-if="!attachments || !attachments.length">
            <b-button
              variant="secondary"
              class="btn-icon mt-1 w-100"
              data-cy= "from-repository"
              v-has-permission="'ED060'"
              v-b-modal="'add-repository-file'"
              :disabled="attachments.length >= 1"
            >
              <feather-icon icon="ServerIcon"/>
              Seleccionar FISABS/FCA desde el repositorio
            </b-button>
          </div>
          <div
            class="col-12"
            v-for="file in attachments"
            :key="file.id"
          >
            <div
              class="row align-items-center"
              v-if="file && file.name && file.name.includes('FISABS')"
            >
              <vs-icon class="col-2" icon="description" size="25px" color="primary" />
              <b class="w-100 text-center col-8">{{ file.name }}</b>
              <vs-button
                class="col-2"
                color="danger"
                type="flat"
                icon="clear"
                @click="removeRepositoryFile(file.id)"
              />
            </div>
          </div>
          <div class="col-12" v-if="!attachments || !attachments.length">
            <span class="danger span-text-validation-danger v-enter-to">
              <small>
                Debes seleccionar un archivo desde el repositorio
              </small>
            </span>
          </div>
        </div>
        <div class="row" v-if="attachments && attachments.length && !loading">
          <div class="col-12">
            <vs-divider />
          </div>
          <div class="col-6">
            <validate-field
              field="orderNumber"
              label="N° Orden de Compra"
              v-slot="{ invalid }"
            >
              <b-input
                name="orderNumber"
                placeholder="Número de Orden de Compra"
                v-model="formData.orderNumber"
                data-vv-as="número de Orden de Compra"
                data-cy="order-number"
                :state="invalid"
              />
            </validate-field>
          </div>
          <div class="col-6">
            <validate-field
              field="receiverGroup"
              label="Dirección /Dpto. /Unidad que Recibe"
              v-slot="{ invalid }"
            >
              <select-options
                name="receiverGroup"
                :alphabetical-sort="true"
                options-group="fisabs-requester-unit"
                v-model="formData.receiverGroup"
                data-vv-as="unidad requirente"
                data-cy="receiver-group"
                v-validate="'required'"
                :invalid="invalid"
              />
            </validate-field>
          </div>
          <div class="col-6">
            <validate-field
              field="deliveryDate"
              label="Fecha Entrega/ofertado según OC"
              v-slot="{ invalid }"
            >
              <date-picker
                name="deliveryDate"
                format="YYYY-MM-DD"
                value-type="YYYY-MM-DD"
                v-model="formData.deliveryDate"
                placeholder="Seleccione la fecha de entrega"
                data-vv-as="fecha de entrega"
                data-cy="delivery-date"
                v-validate="'required'"
                :invalid="invalid"
              />
            </validate-field>
          </div>
          <div class="col-6">
            <validate-field
              field="receptionDate"
              label="Fecha Recepción Conforme del bien o servicio"
              v-slot="{ invalid }"
            >
              <date-picker
                name="receptionDate"
                format="YYYY-MM-DD"
                value-type="YYYY-MM-DD"
                v-model="formData.receptionDate"
                placeholder="Seleccione la fecha de recepción"
                data-vv-as="fecha de recepción"
                data-cy="reception-date"
                v-validate="'required'"
                :invalid="invalid"
              />
            </validate-field>
          </div>
          <div class="col-12">
            <h4>CONTRAPARTE DE LA COMPRA</h4>
          </div>
          <div class="col-6">
            <validate-field
              field="requesterName"
              label="Responsable de elaborar la solicitud"
              v-slot="{ invalid }"
            >
              <ListUser
                class="w-100 mb-0"
                autocomplete
                label=" "
                name="requesterName"
                :invalid="invalid"
                v-validate="'required'"
                :danger="errors.has('formData.requesterName')"
                :state="errors.has('formData.requesterName')"
                :danger-text="errors.first('formData.requesterName')"
                v-model="formData.requesterName"
                data-vv-as="responsable de elaborar la solicitud"
                data-cy="requester-name"
                @full-user="setRequester"
              />
            </validate-field>
          </div>
          <div class="col-6">
            <validate-field
              field="requesterUnit"
              label="Unidad requirente"
              v-slot="{ invalid }"
            >
              <select-options
                name="requesterUnit"
                :alphabetical-sort="true"
                options-group="fisabs-requester-unit"
                v-model="formData.requesterUnit"
                data-vv-as="unidad requirente"
                data-cy="requester-unit"
                v-validate="'required'"
                :invalid="invalid"
              />
            </validate-field>
          </div>
<!--          <div class="col-6">
            <validate-field
              field="purchaseCounterparty"
              label="Contraparte de la Compra"
              v-slot="{ invalid }"
            >
              <b-input
                name="purchaseCounterparty"
                placeholder="Ingrese la conraparte de la compra"
                v-model="formData.purchaseCounterparty"
                data-vv-as="contraparte de la compra"
                data-cy="purchase-counterparty"
                v-validate="'required'"
                :state="invalid"
              />
            </validate-field>
          </div>-->
          <div class="col-12">
            <h4>IDENTIFICACIÓN DEL PROVEEDOR</h4>
          </div>
          <div class="col-6">
            <validate-field
              field="iutProvider"
              label="Rut"
              v-slot="{ invalid }"
            >
              <b-input
                name="iutProvider"
                placeholder="Ingrese el rut"
                v-model="formData.iutProvider"
                data-vv-as="rut proveedor"
                data-cy="iut-provider"
                v-validate="'required'"
                :state="invalid"
              />
            </validate-field>
          </div>
          <div class="col-6">
            <validate-field
              field="businessNameProvider"
              label="Razón Social"
              v-slot="{ invalid }"
            >
              <b-input
                name="businessNameProvider"
                placeholder="Ingrese la razón social"
                v-model="formData.businessNameProvider"
                data-vv-as="razón social proveedor"
                data-cy="business-name-provider"
                v-validate="'required'"
                :state="invalid"
              />
            </validate-field>
          </div>
          <div class="col-12">
            <h4>IDENTIFICACIÓN DE LA COMPRA</h4>
          </div>
          <div class="col-6">
            <b-form-group class="mt-0 mt-md-8">
              <b-form-checkbox
                name="paymentOfService"
                data-cy="payment-of-service"
                data-vv-as="se paga un servicio o producto"
                v-model="formData.paymentOfService"
                class="m-0"
              >
                Se paga un servicio o producto
              </b-form-checkbox>
              <b-form-checkbox
                name="paymentMonthly"
                data-cy="payment-monthly"
                data-vv-as="se paga un monto fijo mensual"
                v-model="formData.paymentMonthly"
                class="m-0"
              >
                Se paga un monto fijo mensual según contrato (contrato mayor a 2 meses)
              </b-form-checkbox>
              <b-form-checkbox
                name="paymentVariable"
                data-cy="payment-variable"
                data-vv-as="se paga un monto variable"
                v-model="formData.paymentVariable"
                class="m-0"
              >
                Se paga un monto según contrato (cuando es contrato de suministro;
                o la contratación lo indica,
                el monto de la cuota o periodicidad se indica en el contrato u orden de compra).
              </b-form-checkbox>
            </b-form-group>
          </div>
          <div class="col-6" />
          <div class="col-6">
            <validate-field
              field="numberOfQuota"
              label="Número pago o cuota"
            >
              <b-input
                name="numberOfQuotas"
                v-model="formData.numberOfQuota"
                data-vv-as="número de pago o cuota"
                data-cy="number-of-quota"
              />
            </validate-field>
          </div>
          <div class="col-6">
            <validate-field
              field="numberOrderApproval"
              label="N° Resolución que aprueba la contratación"
            >
              <b-input
                name="numberOrderApproval"
                v-model="formData.numberOrderApproval"
                data-vv-as="número de Resolución"
                data-cy="number-order-approval"
              />
            </validate-field>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <validate-field
                  field="taxType"
                  label="Tipo de Impuesto"
                  v-slot="{ invalid }"
                >
                  <v-select
                    :options="taxTypeOptions"
                    v-model="formData.taxType"
                    :placeholder="'Seleccione tipo de impuesto'"
                    v-validate="'required'"
                    name="taxType"
                    :reduce="option => option.value"
                    data-vv-as="tipo de impuesto"
                    data-cy="tax-type"
                    @input="onTaxTypeChange"
                  >
                    <template slot="no-options">
                      no hay opciones disponibles
                    </template>
                  </v-select>
                </validate-field>
              </div>
              <div class="col-4" v-if="isOtros">
                <label>Tasa de Impuesto (%)</label>
                <vs-input
                  class="w-100"
                  type="number"
                  data-cy="tax-rate"
                  size="small"
                  v-model="formData.taxRate"
                  min="0"
                  max="100"
                  step="0.01"
                  @input="calculateTotals"
                />
              </div>
              <div class="col-4" v-if="isOtros">
                <label>Monto Impuesto</label>
                <vs-input
                  class="w-100"
                  type="number"
                  data-cy="tax-amount-input"
                  size="small"
                  v-model="formData.taxAmountInput"
                  @input="calculateTotals"
                />
              </div>
              <div class="col-4">
                <label>Descuentos <span class="text-helper">(Monto)</span></label>
                <vs-input
                  class="w-100"
                  type="number"
                  data-cy="discounts"
                  size="small"
                  @input="calculateTotals"
                  v-model="formData.discountAmountInput"
                />
              </div>
              <div class="col-4">
                <label>Recargos <span class="text-helper">(Monto)</span></label>
                <vs-input
                  class="w-100"
                  type="number"
                  data-cy="charges"
                  size="small"
                  @input="calculateTotals"
                  v-model="formData.chargesAmountInput"
                />
              </div>
              <div class="col-4" v-if="showRetentionField">
                <label>Retención de Impuesto (%)</label>
                <vs-input
                  class="w-100"
                  type="number"
                  data-cy="retentionTax"
                  size="small"
                  min="0"
                  max="100"
                  @input="calculateTotals"
                  v-model="formData.withholdingPercentage"
                />
              </div>
              <div class="col-4">
                <label>Valor otra moneda</label>
                <v-select
                  label="label"
                  :options="otherCurrencies"
                  :reduce="currency => currency.label"
                  name="otherCurrency"
                  placeholder="Seleccione moneda"
                  v-model="formData.otherCurrency"
                />
              </div>
            </div>
          </div>
          <div class="col-12 mt-5">
            <h4>SERVICIOS O PRODUCTOS</h4>
            <small v-if="errorItems" class="text-danger">
              Debes seleccionar al menos un ítem
            </small>
          </div>
          <div class="col-12">
            <div class="row mt-2" v-for="(item, index) in formData.items" :key="item.id">
              <div class="col-1 d-flex align-items-center">
                <b-button
                  v-if="item.selected  === true"
                  variant="success"
                  size="sm"
                  @click="unSelectItem(item)"
                >
                  selec.
                </b-button>
                <b-button
                  v-if="item.selected === false"
                  variant="secondary"
                  size="sm"
                  @click="selectItem(item)"
                >
                  no selec.
                </b-button>
              </div>
              <div class="col-5">
                <vs-input
                  label="Nombre de servicio"
                  class="w-100"
                  data-cy="name-service"
                  v-model="item.requiredServiceName"
                />
              </div>
              <div class="col-3">
                <label>Número de serie <span class="text-helper">(Si corresponde)</span></label>
                <vs-input
                  class="w-100"
                  data-cy="serie-number"
                  v-model="item.serieNumber"
                />
              </div>
              <div class="col-3">
                <label>Encargado del bien <span class="text-helper">(Si corresponde)</span></label>
                <v-select
                  class="w-100"
                  :options="users"
                  v-model="item.serviceManager"
                  name="serviceManager"
                  multiple
                  data-vv-as="encargado del bien"
                  data-cy="service-manager"
                >
                  <template slot="no-options">
                    no hay coincidencias para el criterio de búsqueda
                  </template>
                </v-select>
              </div>
              <div class="col-1">
                <vs-input
                  type="number"
                  class="w-100"
                  label="Cantidad"
                  data-cy="quantity"
                  v-model="item.serviceQuantity"
                />
              </div>
              <div class="col-2">
                <vs-input
                  type="number"
                  class="w-100"
                  label="Cant. entregada"
                  data-cy="quantity-delivered"
                  v-model="item.serviceQuantityDelivered"
                  @input="changeReceivedQuantity(item)"
                />
              </div>
              <div class="col-3">
                <vs-input
                  type="number"
                  class="w-100"
                  label="Precio unitario"
                  data-cy="unit-price"
                  v-model="item.serviceAmount"
                  @input="changeReceivedQuantity(item)"
                />
              </div>
              <div class="col-3" />
              <div class="col-3">
                <vs-input
                  type="number"
                  class="w-100"
                  label="Precio total"
                  data-cy="total-price"
                  v-model="item.serviceTotalAmount"
                  disabled
                />
              </div>
              <vs-divider />
            </div>
            <div class="row">
              <div class="col-9">
              </div>
              <div class="col-3 text-right">
                <b-button
                  variant="outline-warning"
                  size="sm"
                  @click="addItem()"
                >
                  agregar
                </b-button>
              </div>
            </div>
          </div>
          <vs-divider />
          <div class="col-12">
            <b-form-group class="mt-0 mt-md-8">
              <b-form-checkbox
                name="applyPenalty"
                data-cy="apply-penalty"
                data-vv-as="aplica multa"
                v-model="formData.applyPenalty"
                class="m-0"
              >
                Aplica multa
              </b-form-checkbox>
            </b-form-group>
          </div>
          <div class="col-9" v-if="formData.applyPenalty">
            <validate-field
              field="percentagePenalty"
              label="Porcentaje de multa"
              v-slot="{ invalid }"
            >
              <b-input
                name="percentagePenalty"
                placeholder="Detallar multa a aplicar (revisar contrato)"
                v-model="formData.percentagePenalty"
                data-vv-as="porcentaje de multa"
                data-cy="percentage-penalty"
                v-validate="{ required: formData.applyPenalty }"
                :invalid="invalid"
              />
            </validate-field>
          </div>
          <div class="col-3" v-if="formData.applyPenalty">
            <validate-field
              field="daysPenalty"
              label="Días de multa"
              v-slot="{ invalid }"
            >
              <b-input
                name="daysPenalty"
                v-model="formData.daysPenalty"
                data-vv-as="días de multa"
                data-cy="days-penalty"
                v-validate="{ required: formData.applyPenalty }"
                :invalid="invalid"
              />
            </validate-field>
          </div>
          <div class="col-12" v-if="formData.applyPenalty">
            <small class="text-warning text-justify">
              En el caso de que el proveedor incumpliese con el plazo de entrega
              del producto o servicio,
              calcular multa según lo establecido en Resolución, Contrato o Convenio Marco.
            </small>
            <br>
            <small class="text-warning text-justify">
              El porcentaje mínimo de la multa aplicar, por cada día hábil o corrido de atraso, será
              de 0.5% y el porcentaje máximo será de 2.5% sobre el valor total neto
              de los bienes o servicios
              no entregados o prestados oportunamente.
            </small>
            <br>
            <small class="text-warning text-justify">
              Las multas serán aplicadas sólo en compras o en contrataciones sobre 5 UTM,
              siempre y cuando el monto calculado de la multa sea superior a 1/3 de UTM.
            </small>
          </div>
          <div class="col-6 mt-2">
            <div
              class="font-weight-bold"
              v-if="selectedDocument && selectedDocument.name && !selectedDocument.name.includes('FCA')"
            >
              Total FISABS: {{formData.totalFisabs | amount}}
            </div>
          </div>
          <div class="col-6 mt-2">
            <div class="row">
              <div class="col-6 mt-3" v-if="!isExempt">
                Total Neto
              </div>
              <div class="col-6 mt-3" v-if="!isExempt">
                {{formData.netAmount | amount}}
              </div>
              <div class="col-6 mt-3">
                Descuentos
              </div>
              <div class="col-6 mt-3">
                {{formData.discountAmount | amount}}
              </div>
              <div class="col-6 mt-3">
                Cargos
              </div>
              <div class="col-6 mt-3">
                {{formData.chargesAmount | amount}}
              </div>
              <div class="col-6 mt-3" v-if="showTaxLine">
                {{taxTypeLabel}}
              </div>
              <div class="col-6 mt-3" v-if="showTaxLine">
                {{formData.taxAmount | amount}}
              </div>
              <div class="col-6 mt-3" v-if="showRetentionField">
                Retención de Impuesto ({{formData.withholdingPercentage}}%)
              </div>
              <div class="col-6 mt-3" v-if="showRetentionField">
                {{formData.retentionTax | amount}}
              </div>
              <div class="col-6 mt-3">
                Subtotal
              </div>
              <div class="col-6 mt-3">
                {{formData.subtotal | amount}}
              </div>
              <div class="col-6 mt-3" v-if="isExempt">
                Monto Exento
              </div>
              <div class="col-6 mt-3" v-if="isExempt">
                {{formData.exemptAmount | amount}}
              </div>
              <div class="col-6 mt-3 font-weight-bold">
                Total Recepción Conforme
              </div>
              <div class="col-6 mt-3">
                {{formData.totalGrossAmount | amount}}
              </div>
            </div>
          </div>
          <div class="col-12">
            <h4>DE LA RECEPCIÓN CONFORME</h4>
          </div>
          <div class="col-6">
            <validate-field
              field="location"
              label="Ubicación del bien"
            >
              <select-options
                multiple
                name="location"
                v-model="formData.location"
                data-vv-as="ubicación del bien"
                data-cy="location"
                options-group="fisabs-service-delivery-location"
              />
            </validate-field>
          </div>
          <div
            class="col-md-6 col-12"
            v-if="formData.location && formData.location.includes(OTHER_ADDRESS)"
          >
            <validate-field
              field="otherAddress"
              label="Ingrese otra dirección"
              v-slot="{ invalid }"
            >
              <b-input
                name="otherAddress"
                placeholder="Ingrese otra dirección"
                v-model="formData.otherAddress"
                data-vv-as="otra dirección"
                data-cy="other-address"
                v-validate="{ required: formData.location.includes(OTHER_ADDRESS) }"
                :state="invalid"
              />
            </validate-field>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-6">
                <label for="responsibleName">Usuario responsable <span class="text-danger"><b>*</b></span></label>
                <v-select
                  class="w-100"
                  :options="users"
                  v-model="formData.responsibles"
                  name="responsibleName"
                  multiple
                  data-vv-as="responsable"
                  data-cy="responsible-name"
                  @input="addResponsible"
                >
                  <template slot="no-options">
                    no hay coincidencias para el criterio de búsqueda
                  </template>
                </v-select>
                <small v-if="errorResponsible" class="text-danger">
                  Debes seleccionar al menos un responsable
                </small>
              </div>
              <div class="col-6 mt-2">
                <validate-field
                  field="responsibleUnit"
                  label="Unidad responsable"
                  v-slot="{ invalid }"
                >
                  <select-options
                    :alphabetical-sort="true"
                    options-group="fisabs-requester-unit"
                    name="responsibleUnit"
                    v-model="formData.responsibleUnit"
                    data-vv-as="unidad responsable"
                    data-cy="responsible-unit"
                    v-validate="'required'"
                    :invalid="invalid"
                  />
                </validate-field>
              </div>
            </div>
          </div>
          <div class="col-12">
            <b-form-group label="Observaciones">
              <b-form-textarea
                name="observations"
                data-cy="observations"
                data-vv-as="observaciones"
                type="text"
                rows="2"
                v-model="formData.observations"
                maxLength="10000"
              />
              <div class="text-right" v-if="formData.observations">
                <small v-tooltip="'Contador de caracteres'">
                  {{ formData.observations.length }}/10000
                </small>
              </div>
              <div
                v-if="errors.has('formData.observations')"
                class="con-text-validation span-text-validation-danger v-enter-to"
                style="height: 19px;"
              >
                <span class="span-text-validation">
                  {{ errors.first('formData.observations') }}
                </span>
              </div>
            </b-form-group>
          </div>
          <div class="col-12">
            Por medio de la presente se da Recepción conforme
            a los bienes y servicios que se detallan en el presente instrumento
          </div>
          <vs-divider />
          <div class="col-12">
            <h4>Documentos</h4>
          </div>
          <div class="col-12">
            <dynamic-file-selector
              v-if="!grcAttachmentsSelectors.loading"
              :selectors="grcAttachmentsSelectors.list
              .slice()
              .sort((a, b) => a.order - b.order)
              .map((sel) => ({ ...sel, ...sel.extra, index: sel.order }))
            "
              :object-to-evaluate="formData"
              :files="dynamicSelectorFiles"
              :reset-key="dfsResetKey"
              @update-files="updateFiles"
              @valid="(valid) => {
              dynamicFileSelectorValid = valid;
            }"
            />
            <div v-else>
              <b-skeleton animation="fade" width="100%"/>
              <b-skeleton animation="fade" width="100%"/>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <UploadFile
                  permission="*"
                  accept="application/pdf, .doc, .docx, .xlsx, .ppt"
                  text="Seleccionar documentos"
                  v-model="fileOthers"
                  upload-to="ed"
                  :button-class="{ 'btn-block': true,
                 'mb-5': errors.has('custom-document.fileName') }"
                  container-class="w-100"
                  @input="addOthersFile()"
                />
              </div>
              <div
                class="col-3"
                v-for="file in formData.attachments"
                :key="file.id"
                v-if="(!file.name || !file.name.includes('FISABS')) && file.origen === 'adjunto' "
              >
                <div
                  class="d-flex flex-column align-items-center"
                >
                  <vs-icon icon="description" size="45px" color="primary" />
                  <b class="text-truncate w-100 text-center">{{ file.name }}</b>
                  <vs-button
                    color="danger"
                    type="flat"
                    icon="clear"
                    @click="removeOthersFile(file.id)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="text-xs text-right">
        <b>Los campos marcados con <span class="text-danger">*</span> son obligatorios</b>
      </div>
      <form-buttons
        :saving="saving"
        :disabled="dfsSelectorsLoading"
        :back="() => this.$router.back()"
        :preview="preview"
        :save="save"
        :saveDraft="saveDraft"
      />
    </div>
    <repository-selector
      :add-file="addRepositoryFile"
      :files="attachments"
      :remove-file="removeRepositoryFile"
      :max-files="1"
      required-file-type="FISABS,FCA"
      :required-approval-state="approvalStateTypes.APPROVED"
    />
  </b-overlay>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { BButton, BFormCheckbox } from 'bootstrap-vue';
import { uuid } from 'vue-uuid';

import HandleDraft from "@/febos/global/documentManagement/mixins/HandleDraft";
import HandlePreLoadData from "@/febos/global/documentManagement/mixins/HandlePreLoadData";
import { ioCreateCustomDocument, ioGetCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import { showToast } from '@/febos/global/customDocuments/utils/showToast';
import { showInvalidFormNotification } from '@/febos/global/customDocuments/utils/notifications';
import { getAttachmentsConfig } from '@/febos/global/customDocuments/utils/attachments';
import { ioListOptions } from '@/febos/servicios/api/herramientas.api';
import PdfPreviewComplete from '@/febos/global/customDocuments/components/PdfPreviewComplete';
import FormButtons from '@/febos/global/customDocuments/components/FormButtons';
import SelectOptions from '@/febos/global/customDocuments/components/SelectOptions';
import ValidateField from '@/febos/global/customDocuments/components/ValidateField';
import DatePicker from '@/febos/global/customDocuments/components/DatePicker';
import SelectGroups from '@/febos/global/customDocuments/components/SelectGroups';
import DynamicFileSelector from '@/febos/global/customDocuments/components/dynamic-file-selector/DynamicFileSelector';
import RepositorySelector from '@/febos/global/customDocuments/components/repository-selector/RepositorySelector';
import ApprovalStateTypes from '@/febos/global/documentManagement/mixins/ApprovalStateTypes';
import dataFISABS from '@/febos/global/customDocuments/vistas/empresas/61980520-8/dataFISABS';
import ListUser from '@/febos/chile/lists/components/ListUser';
import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import { getUsers } from '@/febos/servicios/api/usuarios.api';

const DOC_TYPE = 'GRC';
const OTHER_ADDRESS = 'Otra dirección';
const INITIAL_ITEM = {};

const TAX_TYPE_EXEMPT = 'EXENTO';
const TAX_TYPE_ZONA_FRANCA = 'Zona Franca (0%)';
const TAX_TYPE_OTROS = 'Otros';
const OTROS_OPTION = { value: TAX_TYPE_OTROS, label: 'Otros', rate: null };

export default {
  name: DOC_TYPE,
  components: {
    UploadFile,
    ListUser,
    BButton,
    RepositorySelector,
    BFormCheckbox,
    DynamicFileSelector,
    SelectGroups,
    PdfPreviewComplete,
    FormButtons,
    ValidateField,
    SelectOptions,
    DatePicker,
  },
  mixins: [HandleDraft, ApprovalStateTypes, HandlePreLoadData],
  data() {
    return {
      selectedDocument: {},
      usersCompany: [],
      errorResponsible: false,
      errorItems: false,
      OTHER_ADDRESS,
      loading: false,
      loadingTaxTypes: false,
      taxTypes: [OTROS_OPTION],
      approvalStateTypes: ApprovalStateTypes,
      dynamicFileSelectorValid: false,
      usr: {},
      initialItem: { ...INITIAL_ITEM },
      attachments: [],
      fileOthers: {},
      dynamicSelectorFiles: [],
      otherCurrencies: [],
      loadingCurrencies: false,
      usersList: [],
      formData: {
        observations: '',
        fisabsNumber: '',
        requesterUnit: '',
        otherCurrencyTotal: 0,
        otherCurrency: '',
        responsibles: [],
        requesterUser: {},
        responsibleName: [],
        responsibleUnit: '',
        orderNumber: '',
        receiverGroup: '',
        deliveryDate: '',
        receptionDate: '',
        purchaseCounterparty: '',
        iutProvider: '',
        businessNameProvider: '',
        paymentOfService: '',
        paymentMonthly: '',
        paymentVariable: '',
        numberOfQuota: '',
        numberOrderApproval: '',
        attachments: [],
        applyPenalty: false,
        percentagePenalty: '',
        daysPenalty: '',
        items: [],
        linked: [],
        netAmount: 0,
        discountAmount: 0,
        chargesAmountInput: 0,
        discountAmountInput: 0,
        retentionTaxInput: 0,
        retentionTax: 0,
        chargesAmount: 0,
        exemptSell: false,
        taxType: '',
        taxRate: 0,
        withholdingPercentage: 0,
        taxAmountInput: 0,
        taxRetention: 0,
        taxAmount: 0,
        subtotal: 0,
        exemptAmount: 0,
        totalAmount: 0,
        totalGrossAmount: 0,
      },
      dfsValid: true,
      dfsSelectors: [],
      dfsSelectorsLoading: true,
      dfsFiles: [],
      saving: false,
      formFiles: [],
      error: {
        message: ''
      },
      // PDF Preview
      inPreview: false,
      generatingPreview: false,
      pdfUrl: '',

    };
  },
  computed: {
    ...mapGetters('List', [
      'grcAttachmentsSelectors',
    ]),
    ...mapGetters('Empresas', [
      'empresa',
    ]),
    dontApplyPenalty() {
      return this.formData.applyPenalty === false;
    },
    users() {
      return this.usersCompany
        .map((user) => ({ label: user.nombre, id: user.id, value: user.id }));
    },
    isExempt() {
      return this.formData.taxType === TAX_TYPE_EXEMPT;
    },
    isZonaFranca() {
      return this.formData.taxType === TAX_TYPE_ZONA_FRANCA;
    },
    isOtros() {
      return this.formData.taxType === TAX_TYPE_OTROS;
    },
    showTaxLine() {
      return !this.isExempt && !this.isZonaFranca && this.formData.taxType !== '';
    },
    showRetentionField() {
      return this.formData.taxType !== '' && !this.isExempt;
    },
    taxTypeLabel() {
      if (this.isOtros) return 'Otro Impuesto';
      return this.formData.taxType || '';
    },
    effectiveTaxRate() {
      if (this.isOtros) return (this.formData.taxRate || 0) / 100;
      const found = this.taxTypes.find(t => t.value === this.formData.taxType);
      return found ? found.rate : 0;
    },
    taxTypeOptions() {
      return this.taxTypes.map(t => ({ value: t.value, label: t.label }));
    },
  },
  watch: {
    draftKey() {
      // After getDocumentData or draft loading completes, migrate legacy tax data
      this.migrateDocumentTaxData(this.formData);
    },
  },
  methods: {
    ...mapActions('List', [
      'fetchGrcAttachmentsSelectors',
      'fetchUsers'
    ]),
    onTaxTypeChange() {
      // Reset manual fields when switching away from Otros
      if (!this.isOtros) {
        this.formData.taxAmountInput = 0;
      }
      // Assign predefined rate for non-Otros types
      if (!this.isOtros && this.formData.taxType) {
        const found = this.taxTypes.find(t => t.value === this.formData.taxType);
        if (found && found.rate !== null) {
          this.formData.taxRate = found.rate * 100;
        } else {
          this.formData.taxRate = 0;
        }
      }
      // Clear retention when switching to EXENTO
      if (this.isExempt) {
        this.formData.withholdingPercentage = 0;
      }
      this.calculateTotals();
    },
    migrateDocumentTaxData(document) {
      if (document.taxType) {
        // Documento nuevo formato - usar directamente
        this.formData.taxType = document.taxType;
        this.formData.taxRate = document.taxRate || 0;
        this.formData.withholdingPercentage = document.withholdingPercentage || 0;
      } else if (document.exemptSell === true) {
        this.formData.taxType = TAX_TYPE_EXEMPT;
        this.formData.taxRate = 0;
        this.formData.taxAmount = 0;
      } else if (document.taxAmount > 0) {
        this.formData.taxType = 'IVA (19%)';
        this.formData.taxRate = 19;
      } else {
        this.formData.taxType = '';
        this.formData.taxRate = 0;
      }

      // Validar que el taxType asignado exista en las opciones disponibles (Req 7.2)
      if (this.formData.taxType) {
        const validValues = this.taxTypes.map(t => t.value);
        if (!validValues.includes(this.formData.taxType)) {
          this.$vs.notify({
            title: 'Error',
            text: 'El tipo de impuesto guardado ya no está disponible',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'bottom-right',
            time: 8000,
          });
          this.formData.taxType = '';
          this.formData.taxRate = 0;
        }
      }

      // Migrar retención antigua
      if (!document.withholdingPercentage && document.retentionTaxInput) {
        this.formData.withholdingPercentage = parseFloat(document.retentionTaxInput) || 0;
      }

      // Recalcular totales después de la migración
      this.$nextTick(() => {
        this.calculateTotals();
      });
    },
    async loadTaxTypes() {
      try {
        this.loadingTaxTypes = true;
        const response = await ioListOptions({
          grupoOpcion: 'tipos-impuesto-grc',
          filtros: 'deshabilitado:0'
        });
        const { opciones } = response.data;
        const portalTypes = opciones.map((opt) => {
          const extra = JSON.parse(opt.extra || '{}');
          return {
            value: opt.valor,
            label: opt.descripcion || opt.valor,
            rate: extra.rate ?? 0
          };
        });
        // Append "Otros" which is always local
        this.taxTypes = [
          ...portalTypes,
          OTROS_OPTION
        ];
      } catch (e) {
        // Fallback: keep only "Otros" if portal fails
        console.error('Error loading tax types from portal:', e);
      } finally {
        this.loadingTaxTypes = false;
      }
    },
    async loadCurrencies() {
      try {
        this.loadingCurrencies = true;
        const response = await ioListOptions({
          grupoOpcion: 'monedas-grc',
          filtros: 'deshabilitado:0'
        });
        const { opciones } = response.data;
        this.otherCurrencies = opciones.map((opt) => ({
          id: opt.valor,
          label: opt.descripcion || opt.valor
        }));
      } catch (e) {
        console.error('Error loading currencies from portal:', e);
      } finally {
        this.loadingCurrencies = false;
      }
    },
    updateFiles(files) {
      this.formFiles = [...files];
    },
    setRequester(user) {
      this.formData.requesterUser = user;
    },
    addServiceManager(user) {
      this.formData.responsibles = user;
    },
    addResponsible(user) {
      this.formData.responsibles = user;
    },
    removeOthersFile(fileId) {
      this.formData.attachments = this.formData.attachments
        .filter((file) => file.id !== fileId);
    },
    async addOthersFile() {
      if (!Object.keys(this.fileOthers).length) {
        return;
      }

      if (this.fileOthers.failed) {
        this.error.messageOthers = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      console.log('attach???', this.formData);
      this.formData.attachments.push({ ...this.fileOthers, origen: 'adjunto' });
      this.error.messageOthers = '';
    },
    backToForm() {
      this.inPreview = false;
      this.formData.responsibleName = this.formData.responsibles.map((user) => user.id);
    },
    initialTotals() {
      this.formData = {
        ...this.formData,
        netAmount: 0,
        retentionTax: 0,
        discountAmount: 0,
        chargesAmount: 0,
        taxRetention: 0,
        taxAmount: 0,
        subtotal: 0,
        exemptAmount: 0,
        totalAmount: 0,
        totalGrossAmount: 0,
      };
    },
    calculateTotals() {
      // Preserve manual tax amount input before reset (for "Otros" type)
      const manualTaxAmount = parseInt(this.formData.taxAmountInput || 0);
      this.initialTotals();

      // 1. Calculate grossItemsTotal from selected items
      let grossItemsTotal = 0;
      this.formData.items.forEach((item) => {
        if (item.selected) {
          grossItemsTotal += item.serviceTotalAmount;
        }
      });
      this.formData.subtotal = grossItemsTotal;

      // 2. Get effective tax rate (already handles all types via computed property)
      const taxRate = this.effectiveTaxRate;

      // 3. Calculate netAmount and taxAmount based on taxType
      if (this.isExempt || this.isZonaFranca) {
        // EXENTO / Zona Franca: no tax
        this.formData.netAmount = grossItemsTotal;
        this.formData.taxAmount = 0;
        if (this.isExempt) {
          this.formData.exemptAmount = grossItemsTotal;
        }
      } else if (this.isOtros) {
        // Otros: use manual tax amount, calculate netAmount if rate > 0
        if (taxRate > 0) {
          this.formData.netAmount = Math.round(grossItemsTotal / (1 + taxRate));
        } else {
          this.formData.netAmount = grossItemsTotal;
        }
        this.formData.taxAmount = manualTaxAmount;
      } else if (taxRate > 0) {
        // IVA, Honorarios, etc.: automatic calculation
        this.formData.netAmount = Math.round(grossItemsTotal / (1 + taxRate));
        this.formData.taxAmount = Math.round(this.formData.netAmount * taxRate);
      } else {
        // No tax type selected or rate is 0
        this.formData.netAmount = grossItemsTotal;
        this.formData.taxAmount = 0;
      }

      // 4. Calculate discount and charges from input fields
      this.formData.discountAmount = parseInt(this.formData.discountAmountInput || 0);
      this.formData.chargesAmount = parseInt(this.formData.chargesAmountInput || 0);

      // 5. Calculate retention tax (only when not EXENTO)
      if (!this.isExempt && this.formData.withholdingPercentage > 0) {
        this.formData.retentionTax = Math.round(
          this.formData.netAmount * (this.formData.withholdingPercentage / 100)
        );
      } else {
        this.formData.retentionTax = 0;
      }

      // 6. Calculate total gross amount
      this.formData.totalGrossAmount = this.formData.netAmount
        + this.formData.taxAmount
        - this.formData.discountAmount
        + this.formData.chargesAmount
        + this.formData.retentionTax;
    },
    changeReceivedQuantity(item) {
      if (parseInt(item.serviceQuantityDelivered) > parseInt(item.serviceQuantity)) {
        item.serviceQuantityDelivered = item.serviceQuantity;
      }
      this.formData = {
        ...this.formData,
        items: this.formData.items.map((i) => {
          if (i.id === item.id) {
            return {
              ...i,
              serviceQuantityDelivered: parseInt(item.serviceQuantityDelivered),
              serviceTotalAmount: parseInt(item.serviceAmount) * parseInt(item.serviceQuantityDelivered)
            };
          }
          return i;
        }),
      };
      this.calculateTotals();
    },
    addItem() {
      const clean = {
        id: uuid.v4(),
        requiredServiceName: '',
        serviceQuantity: 0,
        selected: true,
        serieNumber: '',
        serviceManager: '',
        serviceQuantityDelivered: 0,
        serviceTotalAmount: 0,
        serviceAmount: 0
      };
      this.formData.items.push(clean);
    },
    selectItem(item) {
      this.formData = {
        ...this.formData,
        items: this.formData.items.map((i) => {
          if (i.id === item.id) {
            return {
              ...i,
              selected: true,
            };
          }
          return i;
        }),
      };
      this.changeReceivedQuantity(item);
    },
    unSelectItem(item) {
      this.formData = {
        ...this.formData,
        items: this.formData.items.map((i) => {
          if (i.id === item.id) {
            return {
              ...i,
              selected: false,
            };
          }
          return i;
        }),
      };
      this.changeReceivedQuantity(item);
    },
    async getSelectedFileData(file) {
      let typeFile = '';
      if (file && file.name.includes('FCA')) {
        typeFile = 'FCA';
      } else {
        typeFile = 'FISABS';
      }
      try {
        this.loading = true;
        const { id } = file;
        const { data } = await ioGetCustomDocument(typeFile, id, {});
        // this.formData = {};
        // const data = dataFISABS;
        this.selectedDocument = file;
        const formatedItems = data.document.items
          .map((item) => {
            if (typeof item.serviceAmount === 'string') {
              item.serviceAmount = item.serviceAmount.replace(/\$/g, '').replace(/\./g, '');
            }
            return item;
          });
        this.formData.items = formatedItems
          .map((item) => ({
            ...item,
            selected: false,
            serieNumber: '',
            serviceManager: '',
            serviceQuantityDelivered: item.serviceQuantity,
            serviceTotalAmount: parseInt(item.serviceAmount) * parseInt(item.serviceQuantity),
            serviceAmount: parseInt(item.serviceAmount)
          }
          ));
        this.formData.itemsOriginal = [...this.formData.items];
        const attachmentFisabs = data.document.attachments.map((fileAttach) => ({
          id: fileAttach.id,
          locationId: data.document.locationId,
          locationType: data.document.locationType
        }));
        this.formData.linked = [
          {
            id: data.document.id,
            locationId: data.document.locationId,
            locationType: data.document.locationType,
          }
        ];
        this.formData.linked = this.formData.linked.concat(attachmentFisabs);
        this.formData.fisabsNumber = data.document.numero;

        if (typeFile === 'FISABS') {
          this.formData.totalFisabs = data.document.totalSubtotalItemsAmount.replace(/\$/g, '').replace(/\./g, '');
          this.formData.totalFisabs = parseInt(this.formData.totalFisabs, 10);
        }

        this.mapSourceFieldsToForm(data.document);
      } finally {
        this.loading = false;
        this.$nextTick(() => {
          this.$validator.validateAll();
        });
      }
    },
    async loadAttachmentsConfig() {
      this.dfsSelectorsLoading = true;
      try {
        const { selectors } = await getAttachmentsConfig(DOC_TYPE);
        this.dfsSelectors = selectors;
      } finally {
        this.dfsSelectorsLoading = false;
        this.dfsValid = false;
      }
    },
    dfsUpdateFilesdfsUpdateFiles(files) {
      this.formData.attachments = [this.formData.attachments, ...files];
    },
    async addRepositoryFile(file) {
      if (!Object.keys(file).length) {
        return;
      }

      if (file.failed) {
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
      }

      this.attachments.push(file);
      console.log('???', this.attachments);
      this.error.message = '';

      await this.getSelectedFileData(file);
    },
    removeRepositoryFile(id) {
      this.attachments = this.attachments.filter((file) => file.id !== id);
      this.formData.receiverGroup = '';
      this.formData.requesterName = '';
      this.formData.requesterUnit = '';
    },
    mapSourceFieldsToForm(document) {
      const sourceUnit = document.requesterUnit || '';
      if (sourceUnit) {
        this.formData.receiverGroup = sourceUnit;
        this.formData.requesterUnit = sourceUnit;
      }

      const sourceName = document.requesterName || '';
      if (sourceName && this.usersCompany.length > 0) {
        const matchedUser = this.usersCompany.find(
          (user) => user.nombre.toLowerCase().trim() === sourceName.toLowerCase().trim()
        );
        if (matchedUser) {
          this.formData.requesterName = matchedUser.id;
        }
      }
    },
    async validateForm() {
      this.errorResponsible = false;
      this.errorItems = false;
      this.$validator.errors.clear();
      const validDynamicFileSelector = this.dynamicFileSelectorValid;
      const haveNames = this.formData.items.every((item) => item.requiredServiceName
        && item.serviceQuantity && item.serviceAmount);
      const selected = this.formData.items.some((item) => item.selected);
      if (!selected) {
        this.errorItems = true;
        this.$vs.notify({
          title: 'Error al intentar emitir el documento',
          text: 'Debes seleccionar al menos un ítem',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'bottom-right',
          time: 5000,
        });
        return;
      }
      if (!haveNames) {
        this.$vs.notify({
          title: 'Error al intentar emitir el documento',
          text: 'Debes agregar el nombre, cantidad y/o precio de todos los servicios',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'bottom-right',
          time: 5000,
        });
        return;
      }
      const isUpperAmount = this.formData.totalGrossAmount > this.formData.totalFisabs;
      if (isUpperAmount && (this.selectedDocument && !this.selectedDocument.name.includes('FCA'))) {
        this.$vs.notify({
          title: 'Ups!',
          text: 'El monto total de los servicios o productos supera el monto aprobado del FISABS',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'bottom-right',
          time: 5000,
        });
        return;
      }
      if (this.formData.responsibles.length === 0) {
        this.errorResponsible = true;
        return;
      }
      // Tax field validations
      if (!this.formData.taxType) {
        this.$vs.notify({
          title: 'Error al intentar emitir el documento',
          text: 'Seleccione tipo de impuesto',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'bottom-right',
          time: 5000,
        });
        return;
      }
      if (this.isOtros) {
        const taxRate = this.formData.taxRate;
        if (taxRate < 0 || taxRate > 100) {
          this.$vs.notify({
            title: 'Error al intentar emitir el documento',
            text: 'El porcentaje debe estar entre 0 y 100',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'bottom-right',
            time: 5000,
          });
          return;
        }
        if ((taxRate * 100) % 1 !== 0) {
          this.$vs.notify({
            title: 'Error al intentar emitir el documento',
            text: 'Máximo 2 decimales permitidos',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'bottom-right',
            time: 5000,
          });
          return;
        }
      }
      if (this.showRetentionField) {
        const withholdingPercentage = this.formData.withholdingPercentage;
        if (withholdingPercentage < 0 || withholdingPercentage > 100) {
          this.$vs.notify({
            title: 'Error al intentar emitir el documento',
            text: 'El porcentaje de retención debe ser un número entre 0 y 100',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'bottom-right',
            time: 5000,
          });
          return;
        }
      }
      const fieldsValid = await this.$validator.validateAll();

      const result = !!fieldsValid
        && validDynamicFileSelector;

      if (!result) {
        this.$vs.notify({
          title: 'Ups!',
          text: 'Revisa los campos marcados en rojo',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'bottom-right',
          time: 5000,
        });
      }
      if (!fieldsValid) {
        showInvalidFormNotification(this);
      }

      return result;
    },
    getFormData(draft = false) {
      return {
        ...this.formData,
        // Tax fields: explicitly included with proper types (Req 5.1, 6.1, 6.5)
        taxType: this.formData.taxType || '',
        taxRate: Number(this.formData.taxRate) || 0,
        taxAmount: Math.round(Number(this.formData.taxAmount) || 0),
        withholdingPercentage: Number(this.formData.withholdingPercentage) || 0,
        items: this.formData.items
          .filter((item) => draft || item.selected)
          .map((item, indexMap) => ({ ...item, index: indexMap + 1 })),
        linked: [
          ...this.formData.linked,
          {
            number: (this.formData.orderNumber || '').replace(/\s/g, ''),
            locationType: 'MP'
          }
        ],
        fisabsFilesSelected: this.attachments,
      };
    },
    async generatePdf(id) {
      showToast(this, 'Generando archivo PDF', 'En camino...');
      const response = await ioGetCustomDocument(this.$route.params.type, id, { pdf: 'si' });
      showToast(this, 'Archivo generado', 'Listo!', { variant: 'success', autoHideDelay: 3000 });
      window.open(response.data.pdf, '_blank');
      this.$router.push({ name: 'document-management' });
    },
    getMergedAttachments() {
      // IDs que ya están en linked (FISABS, etc.) — no duplicar en attachments
      const linkedIds = new Set((this.formData.linked || []).map((l) => l.id).filter(Boolean));
      // Archivos manuales (origen "adjunto") que el usuario subió directamente
      const manualFiles = (this.formData.attachments || [])
        .filter((file) => file.origen === 'adjunto');
      // Archivos del DynamicFileSelector, excluyendo los de origen "adjunto"
      // porque esos se manejan exclusivamente por formData.attachments
      const selectorFiles = (this.formFiles || [])
        .filter((file) => file.origen !== 'adjunto');
      // Deduplicar por id y excluir los que ya están en linked
      const seen = new Set();
      return [...manualFiles, ...selectorFiles].filter((file) => {
        if (linkedIds.has(file.id)) return false;
        if (seen.has(file.id)) return false;
        seen.add(file.id);
        return true;
      });
    },
    async save() {
      if (!await this.validateForm()) return;
      const from = this.$route.query?.from;
      this.saving = true;
      try {
        showToast(this, 'Guardando documento', 'En camino...', { variant: 'primary', autoHideDelay: 2000 });

        const payload = {
          type: this.$route.params.type,
          query: {
            ...this.$route.query,
            numerar: 'si',
            ...(from === 'draft' && { replace: 'si' }),
          },
          formData: {
            ...this.getFormData(),
            attachments: this.getMergedAttachments(),
            status: '1'
          },
        };
        const response = await ioCreateCustomDocument(payload);
        await this.notifyCreation(response.data.name || '');
        await this.generatePdf(response.data.document.id);
      } catch (e) {
        this.saving = false;
        throw e;
      }
    },
    async saveDraft() {
      const { from } = this.$route.query;
      this.saving = true;
      try {
        showToast(this, 'Guardando borrador documento', 'En camino...', { variant: 'primary', autoHideDelay: 2000 });

        const payload = {
          type: this.$route.params.type,
          query: {
            ...this.$route.query,
            numerar: 'no',
            ...(from === 'draft' && { replace: 'si' })
          },
          formData: {
            ...this.getFormData(true),
            attachments: this.getMergedAttachments(),
            status: '3'
          }
        };
        const response = await ioCreateCustomDocument(payload);
        const docId = response.data?.document?.id || response.data?.documentId;
        if (docId) {
          await this.updateRouteAsDraft(docId);
        }
        showToast(this, 'Borrador guardado correctamente', '¡Listo!', { variant: 'success', autoHideDelay: 3000 });
      } finally {
        this.saving = false;
      }
    },
    async preview() {
      const isValid = await this.validateForm();
      if (!isValid || !this.attachments || !this.attachments.length) {
        return;
      }

      this.pdfUrl = '';
      this.inPreview = true;
      this.generatingPreview = true;

      try {
        showToast(this, 'Generando previsualización', 'En camino...', 'primary', 3000);

        const payload = {
          type: this.$route.params.type,
          query: {
            ...this.$route.query,
            simular: 'si',
          },
          formData: {
            ...this.getFormData(),
            borrador: true,
          }
        };

        const { data: { pdf } } = await ioCreateCustomDocument(payload);

        if (!pdf || pdf === '') {
          showToast(this, 'No se pudo generar la previsualización', 'Ups!', 'warning', 5000);
          this.backToForm();
        }

        this.pdfUrl = `${pdf}#toolbar=0&navpanes=0&scrollbar=0`;
      } catch (e) {
        console.log('EERRPPR', e);
      } finally {
        this.generatingPreview = false;
      }
    },
  },
  async mounted() {
    const { data: { usuarios } } = await getUsers({
      empresaId: this.empresa.id,
      page: 1,
      limit: 9999,
      query: ''
    });

    this.usersCompany = usuarios;
  },
  created() {
    this.usr = this.$store.getters['Usuario/currentUser'];
    this.loadAttachmentsConfig();
    this.fetchGrcAttachmentsSelectors();
    this.loadTaxTypes();
    this.loadCurrencies();
  },
};
</script>
<style>
.text-helper {
  color: #999;
  font-style: italic;
  font-weight: 400;
  font-size: 0.85em;
}
</style>
